import store from '@/store/index';
// import { errorLogout } from '@/utils/errorUtil';
import router from '@/routes/index';
import routerNames from '@/const/routerConstants';

export function setInterceptors(instance) {
  // Add a request interceptor
  instance.interceptors.request.use(
    function (config) {
      // console.log('=========interceptor instance request====================');
      // console.log(config);
      // console.log('=======================================================');
      const isAthenticated = store.getters.IS_AUTHENTICATED;
      
      /*
      const tokenObj = !isAthenticated
        ? store.getters.GET_TOKEN_OBJ
        : store.state;
      */  
      
      // 개발,로컬 - 항상 header token
      // 운영 - 쿠키 없을때만
      // console.log('interceptor request env.NODE_ENV : ' + process.env.NODE_ENV);
      // console.log('interceptor request isAthenticated : ' + isAthenticated);
      
      /*
      if (
        process.env.NODE_ENV === 'local'  ||
        process.env.NODE_ENV === 'development' ||
        (process.env.NODE_ENV === 'production' && !isAthenticated)

      ) {
        console.log('request headers authToken : ' + tokenObj.authToken);
        console.log('request headers userKey : ' + tokenObj.userKey);
        console.log('request headers sessionToken : ' + tokenObj.sessionToken);
        config.headers.authToken = tokenObj.authToken;
        config.headers.userKey = tokenObj.userKey;
        config.headers.sessionToken = tokenObj.sessionToken;
        let userData = encodeURIComponent(JSON.stringify(tokenObj.userData));
        // console.log('request headers userData : ' + userData);
        config.headers.userData = userData;
      }
      */
      
      const tokenObj = store.state;

      config.headers.authToken = tokenObj.authToken;
      config.headers.userKey = tokenObj.userKey;
      config.headers.sessionToken = tokenObj.sessionToken;
      let userData = encodeURIComponent(JSON.stringify(tokenObj.userData));
     
      config.headers.userData = userData;
      // console.dir(config.baseURL + config.url);
      
      return config;
    },
    function (error) {
      // Do something with request error
       console.log('=========interceptor instance request error============');
       console.log(error);
       console.log('=======================================================');
        console.error('interceptor instance request error : ', error);
      return Promise.reject(error);
    },
  );

  // Add a response interceptor
  instance.interceptors.response.use(
    function (response) {
      // console.log('=========interceptor instance response====================');
      // console.log(response);
      // console.log('=======================================================');
      // console.log('interceptor instance response [' + response.config.url + '] : ', response);
      if (response.data.errorCode != null) {
        // 스피너 OFF
        store.commit('SPINNER/OFF_COMMON_SPINNER');
        store.commit('SPINNER/OFF_APP_SPINNER');

        // 에러화면으로 이동
        router.push({
          name: routerNames.Error,
          params: {
            status: response.data.errorCode,
            message: response.data.errorMessage,
          },
        });
      }

      return response;
    },

    function (error) {
       console.log('=========interceptor instance response error1============');
       console.log(error);
       console.log('=======================================================');
        console.error('interceptor instance request error : ', error);
      if (error.response.status >= 500) {
        // 스피너 OFF
        store.commit('SPINNER/OFF_COMMON_SPINNER');
        store.commit('SPINNER/OFF_APP_SPINNER');

        // 에러화면으로 이동
        router.push({
          name: routerNames.Error,
          params: {
            status: error.response.status,
            message: error.response.data.message,
          },
        });

        return false;
      }

      return Promise.reject(error);
    },
  );
  return instance;
}
